import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import * as actions from '../../actions/index';

import './Button.css';

const handleAction = function() {
	const props = this;
	if(props.action && props[props.action]) {
		props[props.action](props.destination);
	} else {
		props.setModal({
			"type": "web",
			"title": props.title || props.children,
			"content": props.destination
		});
	}
}

const Button = (props => (
	<button
		className={`button ${(props.className) ? props.className : ''}`}
		onClick={props.onClick || handleAction.bind(props)}
	>
		{
			props.children &&
			<span className={'button__text'}>{props.children}</span>
		}
		{
			props.icon &&
			<img className={'button__icon'} src={props.icon} alt={'icon'} />
		}
	</button>
));

Button.propTypes = {
	onClick: propTypes.func,
	className: propTypes.string,
	icon: propTypes.string,
	title: propTypes.string,
	children: propTypes.node,

	action: propTypes.string,
	//destination: propTypes.number,
	setModal: propTypes.func,
};

function mapDispatchToProps(dispatch) {
	return {
		goToSection: (sectionID) => {
			dispatch(actions.goToSection(sectionID));
		},
		goToGroup: (groupID) => {
			dispatch(actions.goToGroup(groupID));
		},
		goToStage: (stageID) => {
			dispatch(actions.goToStage(stageID));
		},
	    setModal: (media) => {
	      dispatch(actions.setModal(media));
	    },
	};
}

export default connect(null, mapDispatchToProps)(Button);



// WEBPACK FOOTER //
// ./src/components/Button/Button.js